import React from 'react'
import Help from './Help'
import Map from './Map'
import Action from '../resources/Action'

const Contact = () => {
    return (
        <>
            <Help />
            <Map />
            <Action />
        </>
    )
}

export default Contact